import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const prixRows = [
  { typeKey: 'prix_row1_type', priceKey: 'prix_row1_price' },
  { typeKey: 'prix_row2_type', priceKey: 'prix_row2_price' },
  { typeKey: 'prix_row3_type', priceKey: 'prix_row3_price' },
  { typeKey: 'prix_row4_type', priceKey: 'prix_row4_price' },
];

export default function PrixBardeau() {
  const { t } = useTranslation('bardeau');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="prix" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-10 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-4">
            {t('prix_h2')}
          </h2>
        </div>

        {/* Desktop table */}
        <div
          className={`hidden md:block transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="bg-soft-gray rounded-xl overflow-hidden">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-primary text-white">
                  <th className="text-left px-6 py-4 text-sm font-semibold">{t('prix_table_type')}</th>
                  <th className="text-right px-6 py-4 text-sm font-semibold">{t('prix_table_price')}</th>
                </tr>
              </thead>
              <tbody>
                {prixRows.map((row, idx) => (
                  <tr
                    key={idx}
                    className="border-b border-white last:border-b-0 hover:bg-white transition-colors"
                  >
                    <td className="px-6 py-4 text-slate-primary text-sm">{t(row.typeKey)}</td>
                    <td className="px-6 py-4 text-right font-manrope font-bold text-copper text-base">
                      {t(row.priceKey)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden mt-6 space-y-4">
          {prixRows.map((row, idx) => (
            <div
              key={idx}
              className={`bg-soft-gray rounded-lg p-5 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 100 + 200}ms` }}
            >
              <p className="text-slate-primary text-sm mb-2">{t(row.typeKey)}</p>
              <p className="font-manrope font-bold text-copper text-lg">{t(row.priceKey)}</p>
            </div>
          ))}
        </div>

        <p
          className={`mt-6 text-slate-primary/50 text-xs md:text-sm text-center transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('prix_note')}
        </p>
      </div>
    </section>
  );
}